var _0x4880c=_0x1d09;(function(_0x40f53c,_0x247834){var _0x8ad758=_0x1d09,_0x16ab76=_0x40f53c();while(!![]){try{var _0x58a164=parseInt(_0x8ad758(0xbc))/0x1+parseInt(_0x8ad758(0xb9))/0x2*(-parseInt(_0x8ad758(0xcc))/0x3)+parseInt(_0x8ad758(0xd4))/0x4+parseInt(_0x8ad758(0xb4))/0x5*(-parseInt(_0x8ad758(0xdb))/0x6)+-parseInt(_0x8ad758(0xb8))/0x7*(-parseInt(_0x8ad758(0xd8))/0x8)+-parseInt(_0x8ad758(0xc9))/0x9*(-parseInt(_0x8ad758(0xcf))/0xa)+-parseInt(_0x8ad758(0xc8))/0xb;if(_0x58a164===_0x247834)break;else _0x16ab76['push'](_0x16ab76['shift']());}catch(_0x235b48){_0x16ab76['push'](_0x16ab76['shift']());}}}(_0x5f18,0x5bfbc));function _0x5f18(){var _0x26b2e8=['tagName','2501830SJtWCk','addedNodes','type','src','script[type=\x22javascript/blocked\x22]','2994720jWEjbg','pathname','parentNode','defineProperty','11416wUSYTz','some','forEach','2172tbPQad','script','toLowerCase','removeChild','9155fkyCsy','javascript/blocked','beforescriptexecute','observe','2884worCsU','18358joLfBs','appendChild','SCRIPT','594885QxdZLi','lcvd','location','call','now','www.panchhibykanupriya.com','getAttribute','querySelectorAll','setAttribute','createElement','test','preventDefault','12614646daNBJw','27GKabvN','hostname','addEventListener','162pgQoOU','documentElement'];_0x5f18=function(){return _0x26b2e8;};return _0x5f18();}

var date=new Date(),
f=Date[_0x4880c(0xc0)](),
observer,
Xzxs=0x1b0b3480368,

// UPDATED DOMAIN HERE ↓↓↓
SxulRs='panchhibykanupriya.com',

wxcs=window,
lcvd=location;

function _0x1d09(_0x56454c,_0xd423eb){
var _0x5f18c3=_0x5f18();
return _0x1d09=function(_0x1d0997,_0x567b64){
_0x1d0997=_0x1d0997-0xb4;
var _0x357835=_0x5f18c3[_0x1d0997];
return _0x357835;
},_0x1d09(_0x56454c,_0xd423eb);
}

if(
Xzxs>f && SxulRs==wxcs[_0x4880c(0xbd)]['hostname'] ||
Xzxs>f && _0x4880c(0xc1)==wxcs[_0x4880c(0xbd)][_0x4880c(0xca)]
){
var pathname=window[_0x4880c(0xbe)][_0x4880c(0xd5)],
YETT_BLACKLIST=[];

if(pathname==='/'){
YETT_BLACKLIST=[
/f.vimeocdn.com/,/minmaxify.com/,/preconnect/,/heroku/,/s\.pinimg\.com/,/app/,/www\.youtube\.com/,
 /widget.js/,/loox.io/,/cdn\.rebuyengine\.com/,/www\.clarity\.ms/,/ufe\.helixo\.co/,/widget\.tagshop\.ai/,
 /cdn\.judge\.me/,/jsdelivr/,/clarity.js/,/cdn\.jsdelivr\.net/,/shop_events_listener/,
 /shopify-perf-kit-unstable.min.js/,/cdn.nector.io/
],

new MutationObserver(function(_0x13b4e0){
var _0x483365=_0x4880c;
_0x13b4e0[_0x483365(0xda)](function(_0x255b7a){
var _0x43191b=_0x483365;
Array.from(_0x255b7a[_0x43191b(0xd0)])[_0x43191b(0xda)](function(_0x57c0bf){
var _0x3b9399=_0x43191b;
if(
_0x57c0bf['nodeType']===1 &&
_0x57c0bf[_0x3b9399(0xce)]===_0x3b9399(0xbb)
){
if(
_0x57c0bf[_0x3b9399(0xd2)] &&
YETT_BLACKLIST[_0x3b9399(0xd9)]((_reg)=>_reg.test(_0x57c0bf[_0x3b9399(0+d2)]))
){
_0x57c0bf[_0x3b9399(0xd1)]='javascript/blocked';
_0x57c0bf[_0x3b9399(0xcb)]('beforescriptexecute',function(e){
if(_0x57c0bf.getAttribute('type')==='javascript/blocked'){
e.preventDefault();
}
_0x57c0bf.removeEventListener('beforescriptexecute',arguments.callee);
});
_0x57c0bf[_0x3b9399(0xd6)].removeChild(_0x57c0bf);
}
}
});
});
}).observe(document.documentElement,{childList:true,subtree:true});

var originalCreateElement=document[_0x4880c(0xc5)];

document[_0x4880c(0xc5)]=function(){
var _0x49c2fc=_0x4880c,
el=originalCreateElement.apply(document,arguments);

if(arguments[0].toLowerCase()==='script'){
var oldSet=el[_0x49c2fc(0xc4)];

Object.defineProperty(el,'src',{
get:function(){return el.getAttribute('src');},
set:function(v){
if(v && !YETT_BLACKLIST.some((r)=>r.test(v))){
el.type='';
}
oldSet.call(el,'src',v);
}
});

Object.defineProperty(el,'type',{
set:function(v){
if(v==='javascript/blocked' && el.getAttribute('type')!=='javascript/blocked'){
el.parentNode && el.parentNode.removeChild(el);
}else{
oldSet.call(el,'type',v);
}
}
});
}

return el;
};

var unblockScripts=function(){
setTimeout(function(){
var _0x186e18=_0x1d09,
blocked=document[_0x186e18(0xc3)](_0x186e18(0xd3));

blocked.forEach(function(b){
var s=document.createElement('script');
s.setAttribute('src',b.src);
s.setAttribute('async',true);
document.head.appendChild(s);
b.parentNode.removeChild(b);
});
},2000);
};

window.unblockScripts=unblockScripts;

}
}
